import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import * as stylex from '@stylexjs/stylex';
export default function DeviceAwareDiv400(props) {
  var _props$pad;
  return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.base, props.stylex), {
    style: _objectSpread({
      padding: "".concat((_props$pad = props.pad) !== null && _props$pad !== void 0 ? _props$pad : 0, "px")
    }, props.style)
  }), props.children);
}
DeviceAwareDiv400.propTypes = {
  // proptypes
};

// @ts-ignore
_inject("@media(min-width:901px){.ev1ny23li.ev1ny23li{width:400px}}", 4200);
_inject("@media(min-width:901px){.evajsnjk.evajsnjk{margin-left:auto}}", 4200);
_inject("@media(min-width:901px){.evddidoj.evddidoj{margin-right:auto}}", 4200);
_inject("@media(max-width:900px){.evej7wtx.evej7wtx{width:100%}}", 4200);
var ui = {
  base: {
    "DeviceAwareDiv400__ui.base": "DeviceAwareDiv400__ui.base",
    "@media(min-width:901px)_width": "ev1ny23li",
    "@media(min-width:901px)_marginLeft": "evajsnjk",
    "@media(min-width:901px)_marginInlineStart": null,
    "@media(min-width:901px)_marginInlineEnd": null,
    "@media(min-width:901px)_marginRight": "evddidoj",
    "@media(max-width:900px)_width": "evej7wtx",
    $$css: true
  }
};